// CommercialInvoiceImport.js
import React, { useState, useEffect, useRef, useContext } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import DetailsPageCard from '../../common/DetailsPage/DetailsPageCard';
import CustomModal from "../../common/CustomModal";
import CreateCommercialInvoice from "../CreateForm/CreateCommercialInvoice";
import { useShipmentDetails } from './useShipmentDetails';
import { DELETE_COMMERCIAL_INVOICE, GET_PRODUCTS_LIST, GET_SUPPLIERS_LIST, LIST_COMMERCIAL_INVOICES, LIST_IMPORT_SHIPPING_BOOKINGS, LIST_PROFORMA_INVOICES } from '../../../services/apiRoutes';
import { IconButton } from '@mui/material';
import VisibilityIcon from '@mui/icons-material/Visibility';
import ModeEditOutlineOutlinedIcon from '@mui/icons-material/ModeEditOutlineOutlined';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import MessageBox from '../../common/CustomMessageBox';
import CustomDelete from '../../common/CustomDeleteAlert';
import UpdateCommercialInvoice from '../UpdateForm/UpdateCommercialInvoice';
import axios from 'axios';
import { genericPost } from '../../../services/authServices';
import CommercialInvoiceView from '../ViewDetails/CommercialInvoiceView';
import CustomLoader from '../../common/CustomLoader';
import { AuthContext } from '../../../context/AuthContext';
import { getCommanImportShipmentId, getCurrencyList, getPortMasters, getRoundAmount } from '../../../services/CommonServices';
import CustomStatus from '../../common/CustomStatus';
import { useCompanyDateFormat } from "../../../constants/useCompanyDateFormat";


export default function CommercialInvoiceImport({ fetchButtonList }) {
    const { token } = useContext(AuthContext)
    const companyDateFormat = useCompanyDateFormat();

    const { importShipmentId } = useParams();
    const [open, setOpen] = useState(true);
    const [leadModal, setLeadModal] = useState(false);
    const [viewModal, setViewModal] = useState(false);
    const [activeTab, setActiveTab] = useState('Commercial Invoice');
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const navigate = useNavigate();
    const { shipmentDetails, loading: shipmentLoading } = useShipmentDetails(importShipmentId);
    const [products, setProducts] = useState([]);
    const [suppliersList, setSuppliersList] = useState([]);
    const [portMasters, setPortMasters] = useState([]);
    const [currencyList, setCurrencyList] = useState([]);
    const [deleteAlert, setDeleteAlert] = useState(false)
    const [rowId, setRowId] = useState('')
    const [qtyTotalProforma, setQtyTotalproforma] = useState(0);
    const [qtyTotalComercial, setQtyTotalComercial] = useState(0);
    const [proformaData, setProformaData] = useState([]);
    const [updateModal, setUpdateModal] = useState(false);
    const [message, setMessage] = useState({
        open: false,
        text: '',
        type: ''
    });
    const [commercialInvoiceId, setCommercialInvoiceId] = useState('');
    const [bookingList, setBookingList] = useState([]);

    let supplierId, cifFob, currency;

    const hasFetched = useRef(false);

    useEffect(() => {
        if (shipmentDetails) {
            supplierId = shipmentDetails.supplierId;
            cifFob = shipmentDetails.cifFob.cifFobName;
            currency = shipmentDetails.currency.currency;
            getCommonData();
            fetchData();
            fetchProductsList();
            getSuppliersList();
            fetchDataProforma();
            bookingfetchData();

            hasFetched.current = true;

        }
    }, [shipmentDetails, commercialInvoiceId, token, deleteAlert, leadModal]);
    const fetchDataProforma = async () => {
        setLoading(true);
        try {
            const payload = {
                supplierNamesId: supplierId,
                shipmentId: shipmentId
            };

            const response = await genericPost(LIST_PROFORMA_INVOICES, payload);

            if (response.data.success) {
                let grandTotalQty = 0;
                const proformaInvoices = response.data.proformaInvoice.map((invoice, index) => {
                    const totalQuantity = invoice.particulars
                        .reduce((total, particular) => total + (parseFloat(particular.qty) || 0), 0);

                    grandTotalQty += totalQuantity; // Accumulate to global total

                    const totalRate = invoice.particulars.reduce(
                        (acc, item) => acc + parseFloat(item.rate || 0),
                        0
                    );

                    const firstProductName = invoice.particulars.length > 0
                        ? invoice.particulars[0].products?.productName || 'N/A'
                        : 'N/A';

                    const firstProductUnit = invoice.particulars.length > 0
                        ? invoice.particulars[0].productsUnit?.unitName || 'N/A'
                        : 'N/A';

                    const totalAmount = invoice.particulars.reduce(
                        (acc, item) => acc + ((parseFloat(item.qty) || 0) * (parseFloat(item.rate) || 0)),
                        0
                    );

                    return {
                        proformainvoiceId: invoice.proformaInvoiceId || '',
                        index: (index + 1).toString().padStart(2, '0'),
                        ciNo: invoice.proformaInvoiceNo || '',
                        date: invoice.date || '',
                        dueDate: invoice.dueDate || '',
                        reference: invoice.reference || '',
                        note: invoice.note || '',
                        paymentType: invoice?.paymentMethod?.paymentMethodName || '',
                        paymentTypeColor: invoice?.paymentMethod?.ColorPlate?.color || '',
                        paymentTypeBgColor: invoice?.paymentMethod?.ColorPlate?.backgroundColor || '',
                        upload: invoice.piUpload || '',
                        currencyName: invoice?.currency?.currency || '',
                        productName: firstProductName,
                        firstProductUnit: firstProductUnit,
                        totalQty: totalQuantity,
                        totalRate: `${invoice.currency?.currency_symbol || ''} ${totalRate.toFixed(2)}`,
                        totalAmount: `${invoice.currency?.currency_symbol || ''} ${totalAmount.toFixed(2)}`,
                        particulars: invoice.particulars.map(({
                            particular = '',
                            qty = '',
                            rate = '',
                            unit = ''
                        }) => ({ particular, qty, rate, unit }))
                    };
                });
                setQtyTotalproforma(grandTotalQty);
                setProformaData(proformaInvoices);

            } else {
                setError('No proforma invoices found');
            }
        } catch (error) {
            setError('Error fetching proforma invoices');
            console.error('Error fetching proforma invoices', error);
        } finally {
            setLoading(false);
        }
    };

    const bookingfetchData = async () => {
        setLoading(true);

        try {
            const payload = {
                clientCompanyId: supplierId,
                commanShipmentId: getCommanImportShipmentId,
                shipmentId: shipmentId,
            };

            const response = await genericPost(
                LIST_IMPORT_SHIPPING_BOOKINGS,
                payload
            );

            if (response.data.success && response.data.shippingBooking) {

                const shippingBookingData = response.data.shippingBooking.map((booking) => ({
                    id: booking.shippingBookingId || "",
                    title: booking.bookingNumber || "",
                }));

                setBookingList(shippingBookingData);

            } else {
                setBookingList([]);
                setError("No shipping bookings found");
            }
        } catch (error) {
            setBookingList([]);
            setError("Error fetching shipping bookings");
            console.error("Error fetching shipping bookings", error);
        } finally {
            setLoading(false);
        }
    };

    const fetchData = async () => {
        setLoading(true);
        try {
            const payload = {
                supplierNamesId: supplierId,
                shipmentId: shipmentId
            };
            const response = await genericPost(LIST_COMMERCIAL_INVOICES, payload);

            if (response.data.success) {
                let grandTotalQty = 0;

                const commercialInvoices = response.data.data.map((invoice, index) => {
                    const totalAmount = getRoundAmount(invoice.particulars.reduce((acc, item) => acc + (item.qty * parseFloat(item.rate)), 0));
                    const totalQuantity = invoice.particulars
                        .reduce((total, particular) => total + (parseFloat(particular.qty) || 0), 0);
                    grandTotalQty += totalQuantity;
                    const totalRate = invoice.particulars.reduce((acc, item) => acc + parseFloat(item.rate || 0), 0);
                    const firstProductName = invoice.particulars.length > 0
                        ? invoice.particulars[0].products.productName
                        : 'N/A';
                    const firstProductUnit = invoice.particulars.length > 0
                        ? invoice.particulars[0].productsUnit.unitName
                        : 'N/A';
                    return {
                        commercialInvoiceId: invoice.commercialInvoiceId || '',
                        index: (index + 1).toString().padStart(2, '0'),
                        reference: invoice.reference || '',
                        commercialInvoiceNo: invoice.commercialInvoiceNo || '',
                        dueDate: companyDateFormat(invoice?.dueDate) || '',
                        date: companyDateFormat(invoice?.date) || '',
                        note: invoice.note || '',
                        upload: invoice.ciUpload || '',
                        bookingNumber: invoice.booking?.bookingNumber || "",
                        currencyName: currency || '',
                        totalQty: totalQuantity || '',
                        firstProductName: firstProductName || '',
                        firstProductUnit: firstProductUnit || '',
                        totalRate: `${invoice.currency?.currency_symbol || ''} ${totalRate ? totalRate.toFixed(2) : ""}`,
                        totalAmount: `${invoice.currency?.currency_symbol || ''} ${totalAmount ? totalAmount.toFixed(2) : ""}`,
                        particulars: invoice.particulars.map(({
                            particularName: name = '',
                            qty = '',
                            rate = '',
                            unit = '',
                            description = ''
                        }) => ({
                            name, qty, rate, unit, description
                        }))
                    };
                });
                setData(commercialInvoices);
                setQtyTotalComercial(grandTotalQty);
            } else {
                setError('No commercial invoices found');
            }
        } catch (error) {
            setError('Error fetching commercial invoices');
            console.error('Error fetching commercial invoices', error);
        } finally {
            setLoading(false);
        }
    };

    const handleDelete = async (commercialInvoiceId) => {
        setLoading(true);
        const authToken = sessionStorage.getItem('accessToken');

        try {
            const response = await axios.delete(DELETE_COMMERCIAL_INVOICE(commercialInvoiceId), {
                headers: {
                    Authorization: `Bearer ${authToken}`,
                },
            });

            if (response.status === 200) {
                setDeleteAlert(false);
                fetchButtonList();
                setMessage({
                    open: true,
                    text: "deleted successfully",
                    type: "success",
                });
                fetchData();
            } else {
                setLoading(false);
            }
        } catch (error) {
            setLoading(false);

            if (error.response) {
                if (error.response.status === 409) {
                    setMessage({
                        open: true,
                        text: error.response.data?.error || "Cannot delete Data. Related Shipment exists.",
                        type: "error",
                    });
                } else {
                    setMessage({
                        open: true,
                        text: "An error occurred while deleting the Data.",
                        type: "error",
                    });
                }
            } else {
                console.error("Error deleting Data", error);
                setMessage({
                    open: true,
                    text: "Network error. Please try again later.",
                    type: "error",
                });
            }
        }
    };


    const fetchProductsList = async () => {
        const authToken = sessionStorage.getItem('accessToken');
        const payload = {
            clientCompanyId: supplierId,
        };

        try {
            const response = await axios.post(GET_PRODUCTS_LIST, payload, {
                headers: {
                    Authorization: `Bearer ${authToken}`,
                },
            });

            if (response.status === 200 && response.data.success) {
                const productData = response.data.productsList;
                console.log(productData);
                setProducts(productData);
            } else {
                console.error('Failed to fetch products list:', response.data);
            }
        } catch (error) {
            console.error('Error fetching products list:', error);
        }
    };

    const getSuppliersList = async () => {
        try {
            const payload = {
                clientCompanyId: supplierId,

            };

            const response = await genericPost(GET_SUPPLIERS_LIST, payload, {
            });

            if (response.data && response.data.success && response.data.clientCompanies) {
                const suppliersData = response.data.clientCompanies.map((supplier) => ({
                    id: supplier.clientCompanyId,
                    title: supplier.clientCompanyName,
                }));
                setSuppliersList(suppliersData);

            } else {
                return [];
            }
        } catch (error) {
            console.error('Error fetching suppliers list:', error);
            return [];
        }
    };


    if (!shipmentDetails) {
        return <p>   <CustomLoader open={shipmentLoading} /> </p>;
    }
    const getCommonData = async () => {
        const currencyListData = await getCurrencyList();
        setCurrencyList(currencyListData);
        const getPortMastersData = await getPortMasters()
        setPortMasters(getPortMastersData)
    }
    const handleViewClick = (id) => {
        handleOpenView(id);
    };
    const handleUpdateClick = (id) => {
        setCommercialInvoiceId(id);
        setUpdateModal(true);
    };

    const handleCloseUpdate = () => {
        setUpdateModal(false);
        setCommercialInvoiceId('');
    };
    const handleOpen = () => {
        setLeadModal(true);
    };

    const handleClose = () => {
        setLeadModal(false);
    };

    const handleOpenView = (id) => {
        setCommercialInvoiceId(id);
        setViewModal(true);
    };

    const handleCloseView = () => {
        setViewModal(false);
        setCommercialInvoiceId('');
    };
    const handleOpenDeleteAlert = (rowId) => {
        setDeleteAlert(true)
        setRowId(rowId)
    }


    const companyName = shipmentDetails.supplier.clientCompanyName;
    const phoneNumber = shipmentDetails.supplier.mobile;
    const supplierIdName = shipmentDetails.supplierId;
    const shipmentId = shipmentDetails.shipmentId;
    const currencyId = shipmentDetails?.currency?.id ?? '';
    const currencySymbol = shipmentDetails?.currency?.currency_symbol ?? '';
    const shipmentOrgId = shipmentDetails.importShipmentId;


    const handleBackClick = () => {
        navigate("/app/import/shipement");
    };

    const commercialInvoiceColumns = [
        {
            accessor: 'index', label: 'SN', id: 'index', styleAccessor: {
                textAlign: 'center', maxWidth: '200px', width: "50px"
            },
        },
        {
            id: 'commercialInvoiceNo', label: 'Commercial Invoice', accessor: 'commercialInvoiceNo', styleAccessor: {
                textAlign: 'center'
            }
        },
        {
            id: 'bookingNumber', label: 'Booking Number', accessor: 'bookingNumber', styleAccessor: { textAlign: 'center', },
        },
        {
            id: 'date', label: 'Date', accessor: 'date', styleAccessor: {
                textAlign: 'center'
            }
        },
        { id: 'currencyName', label: 'Currency', accessor: 'currencyName' },

        { id: 'firstProductName', label: 'Product Name', accessor: 'firstProductName' },
        { id: 'firstProductUnit', label: 'Unit', accessor: 'firstProductUnit' },
        {
            id: 'totalQty', label: 'Qty', accessor: 'totalQty', styleAccessor: {
                textAlign: 'center',
            },
        },
        {
            id: 'totalRate', label: 'Rate', accessor: 'totalRate', styleAccessor: {
                textAlign: 'right',
            },
        },
        {
            id: 'totalAmount', label: 'Amount', accessor: 'totalAmount', styleAccessor: {
                textAlign: 'right',
            },
        },
        {
            id: 'qtyStatus',
            label: 'Qty Status',
            accessor: 'qtyStatus',
            Cell: ({ row }) => {
                const proforma = parseFloat(qtyTotalProforma) || 0;
                const commercial = parseFloat(qtyTotalComercial) || 0;
                const qtyUpdated = proforma - commercial;
                const statusText = qtyUpdated > 0 ? 'Partial' : 'Complete';
                const statusStyles = statusText === 'Complete'
                    ? { backgroundColor: '#e9ffe3', color: '#0a2d00', border: '1px solid #0a2d00' }
                    : { backgroundColor: '#FFD7E9', color: '#41001d', border: '1px solid #41001d' };
                return (
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <CustomStatus
                            title={statusText}
                            sx={{
                                textAlign: 'center',
                                display: 'inline-block',
                                ...statusStyles,
                            }}
                        />
                    </div>
                );
            },
            styleAccessor: { textAlign: 'center' },
        },


        {
            id: 'action',
            label: 'Action',
            accessor: 'action',
            Cell: ({ row }) => (
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '1px' }}>
                    <IconButton onClick={() => handleViewClick(row.commercialInvoiceId)} style={{ marginRight: '8px' }}>
                        <VisibilityIcon style={{ color: '#059212' }} />
                    </IconButton>
                    <IconButton onClick={() => handleUpdateClick(row.commercialInvoiceId)} style={{ marginRight: '8px' }}>
                        <ModeEditOutlineOutlinedIcon style={{ color: '#050C9C' }} />
                    </IconButton>
                    <IconButton onClick={() => handleOpenDeleteAlert(row.commercialInvoiceId)}>
                        <DeleteOutlineOutlinedIcon style={{ color: '#E4003A' }} />
                    </IconButton>
                </div>
            ),
        },
    ];

    const proforma = parseFloat(qtyTotalProforma) || 0;
    const commercial = parseFloat(qtyTotalComercial) || 0;
    const qtyUpdated = proforma - commercial;
    const portOfLoading = shipmentDetails?.portOfLoading ?? '';
    const portOfDestination = shipmentDetails?.portOfDestination ?? '';


    return (
        <>
            <div>
                <CustomLoader open={loading} />
                <DetailsPageCard
                    columns={commercialInvoiceColumns}
                    title={'Commercial Invoice'}
                    buttonTitle={'Create Commercial Invoice'}
                    handleOpen={handleOpen}
                    data={data}
                    loading={loading}
                    error={error}
                />
                <CustomModal open={leadModal}  >
                    <CreateCommercialInvoice
                        fetchData={fetchData}
                        setMessage={setMessage}
                        handleClose={handleClose}
                        suppliersList={suppliersList}
                        productsList={products}
                        supplierIdName={supplierIdName}
                        shipmentId={shipmentId}
                        importShipmentId={importShipmentId}
                        currencyId={currencyId}
                        currencySymbol={currencySymbol}
                        currencyList={currencyList}
                        supplierId={supplierId}
                        shipmentOrgId={shipmentOrgId}
                        qtyUpdated={qtyUpdated}
                        portOfLoading={portOfLoading}
                        portOfDestination={portOfDestination}
                        fetchButtonList={fetchButtonList}
                        portMasters={portMasters}
                        bookingList={bookingList}

                    />
                </CustomModal>
                <CustomModal open={updateModal}  >
                    <UpdateCommercialInvoice
                        fetchData={fetchData}
                        setMessage={setMessage}
                        handleClose={handleCloseUpdate}
                        commercialInvoiceId={commercialInvoiceId}
                        suppliersList={suppliersList}
                        productsList={products}
                        currencyList={currencyList}
                        portMasters={portMasters}
                        bookingList={bookingList}
                    />
                </CustomModal>
                <CustomModal open={viewModal} handleClose={handleCloseView}>
                    <CommercialInvoiceView
                        fetchData={fetchData}
                        handleClose={handleCloseView}
                        commercialInvoiceId={commercialInvoiceId}
                        suppliersList={suppliersList}
                        productsList={products}
                    />
                </CustomModal>
                <MessageBox
                    open={message.open}
                    onClose={() => setMessage({ ...message, open: false })}
                    message={message.text}
                    handleClose={() => setMessage({ ...message, open: false })}
                    type={message.type}
                />
                <CustomDelete
                    handleDelete={handleDelete}
                    open={deleteAlert}
                    rowId={rowId}
                    handleClose={() => setDeleteAlert(false)}
                />
                {/* </Main> */}
            </div>
        </>
    );
}
